module.exports = __webpack_public_path__ + "img/walking-phase.72f5e4d0.svg";